import * as React from 'react';

import { IVacancy } from '../../index';
import { Vacancy } from './vacancy/vacancy';
import { IHttpApi } from '@cian/http-api/shared';
import { IUser } from '../../types/user';
import { ILogger } from '@cian/logger';

import * as styles from './vacancy_list.css';

interface IVacancyListProps {
  vacancies: IVacancy[];
  user: IUser;
  logger: ILogger;
  editBackUrl: string;
  httpApi: IHttpApi;
  deleteVacancy(id: number): void;
}

const VacancyList = (props: IVacancyListProps) => (
  <div className={styles['wrapper']}>
    {props.vacancies.length === 0 && (
      <div className={styles['empty_list']}>
        <div className={styles['empty_list-title']}>По данному запросу ничего не найдено</div>
        <span>Измените условия поиска</span>
      </div>
    )}
    {props.vacancies.length > 0 &&
      props.vacancies.map(vacancy => (
        <Vacancy
          onDelete={props.deleteVacancy}
          user={props.user}
          editBackUrl={props.editBackUrl}
          vacancy={vacancy}
          key={vacancy.id}
          logger={props.logger}
          httpApi={props.httpApi}
        />
      ))}
  </div>
);

export { VacancyList };
